var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 43,
    viewBox: "0 0 22 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7632 20.0039H3.76172V22.9534H17.7632V20.0039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7632 1H3.76172V3.94954H17.7632V1Z",
    fill: "#7B7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7632 38.9707H3.76172V41.9202H17.7632V38.9707Z",
    fill: "#7B7B7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94962 23.9619H1V37.9629H3.94962V23.9619Z",
    fill: "#7B7B7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7153 23.9619H17.7656V37.9629H20.7153V23.9619Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94962 4.99512H1V18.9961H3.94962V4.99512Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7153 4.99512H17.7656V18.9961H20.7153V4.99512Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e9c593c5569cf08521b415e046df9fc8.svg";
export { ForwardRef as ReactComponent };